<template>
  <section class="hero-section">
    <div class="overlay"></div>
    <div class="container">
      <div class="hero-content">
        <h1>{{ title }}</h1>
        <p>{{ subtitle }}</p>
        <router-link :to="ctaLink" class="btn btn-hero">{{ ctaText }}</router-link>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HeroSection',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    },
    ctaText: {
      type: String,
      default: 'Learn More'
    },
    ctaLink: {
      type: String,
      default: '/'
    }
  }
}
</script>

<style scoped>
.hero-section {
  height: 600px;
  background-image: url('https://images.unsplash.com/photo-1506306460327-3164753b74c7?ixlib=rb-4.0.3');
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
}

.container {
  position: relative;
  z-index: 2;
}

.hero-content {
  max-width: 700px;
  color: white;
}

.hero-content h1 {
  font-size: 3.5rem;
  margin-bottom: 20px;
}

.hero-content p {
  font-size: 1.2rem;
  margin-bottom: 30px;
}

.btn-hero {
  font-size: 18px;
  padding: 15px 30px;
}

@media (max-width: 768px) {
  .hero-section {
    height: 450px;
  }
  
  .hero-content h1 {
    font-size: 2.5rem;
  }
  
  .hero-content p {
    font-size: 1rem;
  }
}
</style>